import { useT } from "../i18n";

export function LangSwitch() {
  const { lang, setLang } = useT();
  return (
    <div className="langswitch" role="group" aria-label="Language">
      <button
        className={lang === "pt" ? "active" : ""}
        onClick={() => setLang("pt")}
        type="button"
      >
        PT
      </button>
      <button
        className={lang === "en" ? "active" : ""}
        onClick={() => setLang("en")}
        type="button"
      >
        EN
      </button>
    </div>
  );
}
